import transform from 'slugify'
import config from '../config'
import { SlugifyLocale } from 'config/config.type'

const putSlashAtEnd = (s: string): string => (s.endsWith('/') ? s : s + '/')

export function extendedSlugify(
  s: string,
  slugifyLocale: SlugifyLocale = config.slugifyLocale,
  splitChar: string = ' > ',
  removeChars: string[] = [], // Characters that should be removed before slugifying to wdv-4093
  ignoredChars: string[] = [], // Characters that should be ignored to wdv-3955
  endWithSlash: boolean = false
) {
  if (removeChars.length > 0) {
    // Remove specified characters,that doesnt removet with slugify-strict mode
    // e.g. ,0, ®    
    s = removeChars.reduce((acc, char) => acc.replaceAll(char, ''), s)
  }

  if (ignoredChars.length > 0) {
    // Create placeholder mappings
    const placeholderMap = Object.fromEntries(
      ignoredChars.map((char, index) => [char, `__placeholder_${index}__`])
    )

    // Replace special chars with placeholders
    const url = ignoredChars.reduce(
      (acc, char) => acc.replaceAll(char, placeholderMap[char]),
      s
    )

    // Slugify the URL
    const slugifiedUrl = url
      .split(splitChar)
      .map((s) =>
        transform(s, {
          replacement: '-', // replace spaces with replacement character, defaults to `-`
          remove: undefined, // remove characters that match regex, defaults to `undefined`
          lower: true, // convert to lower case, defaults to `false`
          strict: true, // strip special characters except replacement, defaults to `false`
          locale: slugifyLocale // language code of the locale to use
        })
      )
      .join('/')

    // Restore special characters
    const result = ignoredChars.reduce(
      (acc, char) => acc.replaceAll(placeholderMap[char], char),
      slugifiedUrl
    )

    return endWithSlash ? putSlashAtEnd(result) : result
  }
  // If no ignored characters, just slugify the string
  const slugified = s
    .split(splitChar)
    .map((s) =>
      transform(s, {
        replacement: '-', // replace spaces with replacement character, defaults to `-`
        remove: undefined, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: true, // strip special characters except replacement, defaults to `false`
        locale: slugifyLocale // language code of the locale to use
      })
    )
    .join('/')

  return endWithSlash ? putSlashAtEnd(slugified) : slugified
}

export default function slugify(
  s: string,
  slugifyLocale: SlugifyLocale = config.slugifyLocale
) {
  const removeChars = [',0', '®', '|'] //wdv-4093
  return extendedSlugify(s, slugifyLocale, ' > ', removeChars, [], true)
}
export function slugifyWithSlashes(
  s: string,
  slugifyLocale: SlugifyLocale = config.slugifyLocale
) {
  const removeChars = [',0', '®', '|'] //wdv-4093
  return extendedSlugify(s, slugifyLocale, '/', removeChars)
}

export function slugifyForSeries(
  s: string,
  slugifyLocale: SlugifyLocale = config.slugifyLocale
) {
  // const removeChars = [',0', '®', '|'] //wdv-4093
  const ignoredChars = [
    '&',
    '@',
    '#',
    '$',
    '%',
    '^',
    '*',
    '(',
    ')',
    '+',
    '=',
    '{',
    '}',
    '[',
    ']',
    '|',
    '\\',
    ';',
    '"',
    "'",
    '<',
    '>',
    ',',
    '?'
  ] //wdv-3955
  return extendedSlugify(s, slugifyLocale, '/', [], ignoredChars, true)
}
